import React from 'react';

import moment from 'moment';
import { Input, Checkbox, Tooltip, notification, Button } from 'antd/lib';

import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import { withApollo } from 'react-apollo';

import FormVentaSello from '../../formularios/FormVentaSello';

const FormItem = Form.Item;
const { TextArea } = Input;

class FormArregloExtrajudicial extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      confirmDirty: false,
      autoCompleteResult: [],
      existeVenta: false,
    };
  }

  onFinalizarExento = () => {
    let datos = {
      motivo: this.props.form.getFieldValue('motivo'),
      existeVenta: this.state.existeVenta,
    };

    if (!datos.motivo) {
      notification.error({
        message: 'Por favor, ingrese el motivo del pedido.',
      });
      return;
    }

    this.props.onSubmit(datos, false);
  };

  onFinalizar = (ventaSinStock, detalles, datosPonset, extras) => {
    let datos = {
      motivo: this.props.form.getFieldValue('motivo'),
      existeVenta: this.state.existeVenta,
      detalles,
      datosPonset,
      extras,
    };

    if (!datos.motivo) {
      notification.error({
        message: 'Por favor, ingrese el motivo del pedido.',
      });
      return;
    }

    this.props.onSubmit(datos, ventaSinStock);
  };

  onFinalizarMP = (ventaSinStock, detalles, datosMP, extras) => {
    let datos = {
      motivo: this.props.form.getFieldValue('motivo'),
      existeVenta: this.state.existeVenta,
      detalles,
      datosMP,
      extras,
    };

    if (!datos.motivo) {
      notification.error({
        message: 'Por favor, ingrese el motivo del pedido.',
      });
      return;
    }

    this.props.onSubmit(datos, ventaSinStock);
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onChangeCheckbox = e => {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      existeVenta: e.target.checked,
    });
  };

  render() {
    moment.locale('en');
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Organismo</h1>

        <Form className="formularios">
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Motivo del pedido
                <Tooltip title="Motivo del pedido extrajudicial ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('motivo', {
              rules: [
                {
                  required: true,
                  message:
                    'Por favor, ingresar el texto con el motivo del pedido!',
                  whitespace: true,
                },
              ],
            })(<TextArea rows={6} />)}
          </FormItem>

          <FormItem>
            <Checkbox
              style={{ marginLeft: '30%' }}
              onChange={this.onChangeCheckbox}
            >
              Computar Venta
            </Checkbox>
          </FormItem>

          {this.state.existeVenta && (
            <div>
              <hr />
              <FormVentaSello
                opcionRender={1}
                organismo={this.props.organismo}
                crearVentaCompleta={(detalles, datosPonset, extras) => {
                  this.onFinalizar(true, detalles, datosPonset, extras);
                }}
                crearVentaMercadoPago={(detalles, datosMP, extras) => {
                  this.onFinalizarMP(true, detalles, datosMP, extras);
                }}
                tramite={'ACUERDOS EXTRAJUDICIALES'}
              />
              <hr />
            </div>
          )}

          {!this.state.existeVenta && (
            <FormItem {...tailFormItemLayout}>
              <Button
                type="primary"
                loading={this.props.loading}
                disabled={this.state.existeVenta}
                onClick={this.onFinalizarExento}
              >
                <Icons.SolutionOutlined />
                Exento
              </Button>
            </FormItem>
          )}
        </Form>
      </div>
    );
  }
}

export default Form.create()(withApollo(FormArregloExtrajudicial));
